import api from "./base";
import cyclic from "./cyclicUrl";

export const fetchDataWithAxios = async (method, endpoint, url = "cyclic") => {
  let baseurl = url == "render" ? api : cyclic; 
  const response = await baseurl[method](endpoint);
  return response;
};
